import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  selectedTab: 2,
  priorSelected: "",
  selectedIndustry: "",
  selectedApplication: "",
  currentStep: 1,
  previousStep: 0,
  topProducts: [], // Store top products globally for search recommendations
};

const productSlice = createSlice({
  name: "Product",
  initialState,
  reducers: {
    setSelectedTab: (state, action) => {
      state.selectedTab = action.payload;
    },
    setCurrentStep: (state, action) => {
      state.previousStep = state.currentStep;
      state.currentStep = action.payload;
    },
    setSelected: (state, action) => {
      if (action.payload.type === "Industry") {
        state.selectedIndustry = action.payload.data;
        if (action.payload.step === 1) {
          state.priorSelected = action.payload.type;
          state.selectedApplication = "";
        }
      } else {
        state.selectedApplication = action.payload.data;
        if (action.payload.step === 1) {
          state.priorSelected = action.payload.type;
          state.selectedIndustry = "";
        }
      }
    },
    resetSelection: (state) => {
      state.selectedTab = 2;
      state.priorSelected = "";
      state.selectedIndustry = "";
      state.selectedApplication = "";
      state.currentStep = 1;
      state.previousStep = 0;
    },
    setTopProducts: (state, action) => {
      state.topProducts = action.payload;
    },
  },
});

export const { setSelectedTab, setCurrentStep, setSelected, resetSelection, setTopProducts } =
  productSlice.actions;
export default productSlice.reducer;
